import axios from 'axios'
import Vue from 'vue'
import {ACCESS_TOKEN, USER_INFO} from '../store/mutation-types'
import store from '../store'

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.baseURL

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}` // 让每个请求携带自定义 token 请根据实际情况自行修改
    config.headers['userId'] = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO).id : '' // 让每个请求携带自定义 用户id
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use((response) => {
  // 针对后端返回标识 做退出操作
  if (response.data.code && ((response.data.code).toString() === '401' || (response.data.code).toString() === '1001')) {
    store.dispatch('Logout')
  }
  return response.data
}, (error) => {
  return Promise.reject(error)
})
export const apiGet = (url, params) => {
  let requestObj = {url, params, method: 'get'}
  if (params && params.isPDF) {
    requestObj.responseType = 'arraybuffer'
  }
  return new Promise((resolve, reject) => {
    axios(requestObj).then(res => {
      if (res.code === 0 || (typeof res) === 'string') {
        resolve(res)
      } else {
        reject(res)
      }
    }).catch(err => {
      reject(err)
    })
  })
}
export const apiDelete = (url, params) => {
  let requestObj = {url, params, method: 'delete'}
  return new Promise((resolve, reject) => {
    axios(requestObj).then(res => {
      if (res.code === 0 || (typeof res) === 'string') {
        resolve(res)
      } else {
        reject(res)
      }
    }).catch(err => {
      reject(err)
    })
  })
}
export const apiPost = (url, params, isUpload) => {
  return new Promise((resolve, reject) => {
    if (isUpload) {
      let requestObj = {
        url,
        data: params,
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }
      axios(requestObj).then(res => {
        if (res.code === 0 || (typeof res) === 'string') {
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
      return
    }
    let requestObj = {url, data: params, method: 'post'}
    if (params && params.isPDF) {
      requestObj.responseType = 'arraybuffer'
      delete params.isPDF
    }
    axios(requestObj).then(res => {
      if (res.code === 1 || res.code === 0 || (typeof res) === 'string') {
        resolve(res)
      } else {
        reject(res)
      }
    }).catch(err => {
      reject(err)
    })
  })
}
export const apiPut = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.put(url, params).then(res => {
      if (res.code === 0 || (typeof res) === 'string') {
        resolve(res)
      } else {
        reject(res)
      }
    }).catch(err => {
      reject(err)
    })
  })
}
export const apiPatch = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.patch(url, params).then(res => {
      if (res.code === 0 || (typeof res) === 'string') {
        resolve(res)
      } else {
        reject(res)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

export const apiAxios = axios



// WEBPACK FOOTER //
// ./src/api/index.js